import BillAccountIcon from '@material-ui/icons/ViewList';

import BillAccountList from './BillAccountList';

export default {
  list: BillAccountList,
  icon: BillAccountIcon,
};
